<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Loader -->
@if (dataLoading) {
<div class="loading-container" style="text-align: center; padding: 50px;">
  <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
</div>
}

<!-- Modal Body -->
@if (!dataLoading) {
<div class="modal-body-wrapper" [hidden]="minimise">
  <div class="modal-body-content">
    <!-- Entity Details -->
    <div class="entity-details">
      <h5>
        Entity Details : {{rowData.LE_NAME}} ({{rowData.LEID}}/{{rowData.CDR_NO}}/{{rowData.REPORTING_PERIOD}})
      </h5>
    </div>
    
    <!-- Info Message -->
    <div class="info-message">
      <h5>
        <i class="fa fa-info-circle"></i>
        Enter the totals for each type of transaction that occured during the annual accounting period between the FDE or FB and the persons listed in columns (b) through (f).
        All Amounts are in US Dollars translated from functional currency at the appropriate exchange rate for the FDE's or FB's tax year.
      </h5>
    </div>
    
    <!-- Currency Information -->
    <div class="currency-info">
      <h5>
        The relevant functional currency and the exchange rate used throughout this schedule : {{rowData.FUNCTIONAL_CURRENCY}} &emsp; {{rowData.WTD_AVG_RATE}}
      </h5>
    </div>
    
    <!-- Schedule M Table -->
    <div class="table-container">
      <table class="table table-bordered schedule-m-table">
        <thead>
          <tr>
            <th style="width: 58px" rowspan="2" class="text-center">Line No</th>
            <th rowspan="2" class="text-center">Transactions of foreign disregarded entity<br>(a)</th>
            <th style="width: 200px" rowspan="2" class="text-center">U.S. person filing this return (System)<br>(b1)</th>
            <th style="width: 200px" rowspan="2" class="text-center">U.S. person filing this return (Override)<br>(b)</th>
            <th style="width: 200px" rowspan="2" class="text-center">Any domestic corporation or partnership controlled by U.S. person filing this return (System)<br>(c1)</th>
            <th style="width: 200px" rowspan="2" class="text-center">Any domestic corporation or partnership controlled by the filer (Override)<br>(c)</th>
            <th style="width: 200px" rowspan="2" class="text-center">Any other foreign corporation or partnership controlled by the filer (other than the tax owner) (System)<br>(d1)</th>
            <th style="width: 200px" rowspan="2" class="text-center">Any foreign corporation or partnership controlled by the filer (other than the tax owner) (Override)<br>(d)</th>
            <th style="width: 200px" rowspan="2" class="text-center">10% or more U.S. shareholder of any corporation controlling the tax owner<br>(e)</th>
            @if (rowData.LE_TAX_TYPE !== 'BRPTP') {
<th style="width: 200px" rowspan="2" class="text-center">10% or more U.S. shareholder, or other owner, of any entity controlling the tax owner<br>(f)</th>
}
          </tr>
        </thead>
        <tbody>
          @for (lines of irsF8858ScheduleMData; track $index) {

          @if (lines.line_type !== 'filer') {
<tr
              [ngStyle]="lines.backgroudColor" 
              [class.total-row]="lines.line_type === 'total'">
            <!-- Line Number -->
            <td style="width: 58px" class="text-center">{{ lines.line_no }}</td>
            
            <!-- Line Description -->
            <td>{{ lines.line_Description }}</td>
            
            <!-- Column b1 (System - readonly) -->
            <td class="text-right" style="width: 200px">
              <div>
                {{ (lines.col_b1?.VALUE | number) }}
              </div>
            </td>
            
            <!-- Column b (Override - editable) -->
            <td class="text-right" style="width: 200px">
              @if (lines.line_type !== 'total' && lines.col_b) {
<div>
                <input type="text" 
                       [(ngModel)]="lines.col_b.VALUE" 
                       size="22" 
                       class="text-right form-control input-sm numText"
                       onlyIntegersWithLength
                       (ngModelChange)="computeColValues('b', lines.line_no, lines.col_b?.VALUE)" />
              </div>
}
              @if (lines.line_type === 'total') {
<div>{{(lines.col_b?.VALUE | number)}}</div>
}
            </td>
            
            <!-- Column c1 (System - readonly) -->
            <td class="text-right" style="width: 200px">
              <div>
                {{ (lines.col_c1?.VALUE | number) }}
              </div>
            </td>
            
            <!-- Column c (Override - editable) -->
            <td class="text-right" style="width: 200px">
              @if (lines.line_type !== 'total' && lines.col_c) {
<div>
                <input type="text" 
                       [(ngModel)]="lines.col_c.VALUE" 
                       size="22" 
                       class="text-right form-control input-sm numText"
                       onlyIntegersWithLength
                       (ngModelChange)="computeColValues('c', lines.line_no)" />
              </div>
}
              @if (lines.line_type === 'total') {
<div>{{(lines.col_c?.VALUE | number)}}</div>
}
            </td>
            
            <!-- Column d1 (System - readonly) -->
            <td class="text-right" style="width: 200px">
              <div>
                {{ (lines.col_d1?.VALUE | number) }}
              </div>
            </td>
            
            <!-- Column d (Override - editable) -->
            <td class="text-right" style="width: 200px">
              @if (lines.line_type !== 'total' && lines.col_d) {
<div>
                <input type="text" 
                       [(ngModel)]="lines.col_d.VALUE" 
                       size="22" 
                       class="text-right form-control input-sm numText"
                       onlyIntegersWithLength
                       (ngModelChange)="computeColValues('d', lines.line_no)" />
              </div>
}
              @if (lines.line_type === 'total') {
<div>
                {{ (lines.col_d?.VALUE | number) }}
              </div>
}
            </td>
            
            <!-- Column e (editable) -->
            <td class="text-right" style="width: 200px">
              @if (lines.line_type !== 'total' && lines.col_e) {
<div>
                <input type="text" 
                       [(ngModel)]="lines.col_e.VALUE" 
                       size="22" 
                       class="text-right form-control input-sm numText"
                       onlyIntegersWithLength
                       (ngModelChange)="computeColValues('e', lines.line_no)" />
              </div>
}
              @if (lines.line_type === 'total') {
<div>{{ (lines.col_e?.VALUE | number) }}</div>
}
            </td>
            
            <!-- Column f (editable, conditional display) -->
            @if (rowData.LE_TAX_TYPE !== 'BRPTP') {
<td class="text-right" style="width: 200px">
              @if (lines.line_type !== 'total' && lines.col_f) {
<div>
                <input type="text" 
                       [(ngModel)]="lines.col_f.VALUE" 
                       size="22" 
                       class="text-right form-control input-sm numText"
                       onlyIntegersWithLength
                       (ngModelChange)="computeColValues('f', lines.line_no)" />
              </div>
}
              @if (lines.line_type === 'total') {
<div>{{ (lines.col_f?.VALUE | number) }}</div>
}
            </td>
}
          </tr>
}
          
}
        </tbody>
      </table>
    </div>
  </div>
</div>
}

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>

